import React, { useContext, useEffect, useState } from "react";
import "./CreateDemat.css";
import zerodha from "../../../assets/Demat/zerodha-1.svg";

// import Kotak1 from "../../../assets/Demat/Kotak1.svg"
import Axis from "../../../assets/Demat/Axis.svg";
// import angel1 from "../../../assets/Demat/angel1.svg"
// import edelweiss1 from "../../../assets/Demat/edelweiss1.svg"
// import iifl1 from "../../../assets/Demat/iifl1.svg"
import iifl1 from "../../../assets/Demat/IIFL-Securities-Horizontal-PNG.png";
import Kotak from "../../../assets/Demat/Kotak.png";
import ventura from "../../../assets/Demat/ventura.jpg";
import Bajaj from "../../../assets/Demat/Bajaj.png";
import religare from "../../../assets/Demat/Religare.svg";
import HDFC from "../../../assets/Demat/HDFC.png";
import Marwadi from "../../../assets/Demat/Marwadi.png";

import icici1 from "../../../assets/Demat/icici1.svg";
// import hdfc1 from "../../../assets/Demat/hdfc1.svg"
import UserProfileModal from "../UserProfileModal";
// import {toIndianCurrency} from "../../../helperFunctions/helperFunctions"
// import { Navigate } from "react-router-dom";
import Centrum from "../../../assets/Demat/Centrum.jpg";
import { Context } from "../../../services/apiContext";
import { useNotificationActionsContext } from "../../../components/notificationModal/useModal";
import configData from "../../../utils/config/config.json";
import { getClientIp } from "../../../helperFunctions/helperFunctions";
import { useSearchParams } from "react-router-dom";

const DematDashboard = ({
  nextStep,
  referrer,
  showcomponent,
  hidecomponent,
}) => {
  const [openstatus, setopenstatus] = useState(false);
  const [confirmationName, setconfirmationName] = useState("");
  const [utmSource, setUtmSource] = useState("");
  const [showmodal, setshowmodal] = useState(false);
  const [selectedNamelinnk, setselectedNamelinnk] = useState({});
  const contextapi = useContext(Context);
  const [referal, setReferal] = useState(referrer);
  console.log(referal);
  const setNotifi = useNotificationActionsContext();
  const showAll = () => {
    nextStep();
  };


  const [searchParams, setSearchParams] = useSearchParams();
  const isReferral = !!searchParams.get('refid')

  useEffect(() => {
    var utmSourceBE = contextapi.getSession("utmSource");
    console.log(utmSourceBE);
    setUtmSource(utmSourceBE);
  }, []);

  const [redirectionLink, setredirectionLink] = useState("");
  const openRedirectionLink = (link, name) => {
    setshowmodal(true);
    renderPophere();
    setopenstatus(true);
    setconfirmationName("dematRedirection");
    setredirectionLink(link);
    setselectedNamelinnk(name);
  };
  const closestatus = (that) => {
    console.log(that);
    console.log(that);
    showcomponent();
    setopenstatus(false);
    setshowmodal(false);
    renderPophere();
    setconfirmationName("");

    if (that === "yes") {
      if (redirectionLink !== "") {
        var cseDataMB = contextapi.getSession("cseData");
        var kfinRef = referal;
        console.log(kfinRef);
        if (cseDataMB) {
          var useDataa = contextapi.getSession("userData");
          cseDataMB.Name = useDataa.name;
          cseDataMB.EmailID = useDataa.email;
          cseDataMB.Mobile = useDataa.mobile;
          console.log(cseDataMB);
          logCSEData(cseDataMB, "CSC");
        } else if (kfinRef) {
          var useDatan = contextapi.getSession("userData");
          let newData = {
            utm_source: kfinRef.utm_source,
            utm_medium: "IPO",
            utm_campaign: kfinRef.utm_camp_id,
            sequence_no: "KFintech_ipo_site",
            agentCode: "KFintech_ipo_site",
            ba_code: "KFintech_ipo_site",
            referenceNo: kfinRef.referral_id,
            Name: useDatan.name,
            EmailID: useDatan.email,
            Mobile: useDatan.mobile,
            checkSum:
              "5529cc0f1f01db5904dfbf080a5452325d500beb955ad28ec523e86ebd1519b5",
            ts: new Date().toISOString(),
          };
          logCSEData(newData, "KFintech_referal");
        } else {
          var useData = contextapi.getSession("userData");
          let newData = {
            utm_source: "Website",
            utm_medium: "IPO",
            utm_campaign: "1",
            sequence_no: "KFintech_ipo_site",
            agentCode: "KFintech_ipo_site",
            ba_code: "KFintech_ipo_site",
            referenceNo: "KFINTECH-500100100013-120132-10000133",
            Name: useData.name,
            EmailID: useData.email,
            Mobile: useData.mobile,
            checkSum:
              "5529cc0f1f01db5904dfbf080a5452325d500beb955ad28ec523e86ebd1519b5",
            ts: new Date().toISOString(),
          };

          logCSEData(newData, "KFintech");
        }
        window.open(redirectionLink, "_blank");
      }
    }
  };
  const logCSEData = async (data, isSocureKfintect) => {
    var url = "/demat/logTransCall";
    var useData = contextapi.getSession("userData").user_key;
    let newData = {};

    newData.user_key = useData;
    newData.src_id = isSocureKfintect;
    newData.utm_src = data.utm_source;
    newData.utm_medium = data.utm_medium;
    newData.utm_campaign = data.utm_campaign;
    newData.idno = data.utm_campaign;
    newData.refno = data.referenceNo;
    newData.agent_code = data.agentCode ? data.agentCode : "";
    newData.ba_code = data.ba_code ? data.ba_code : "";
    newData.sequence_no = data.sequence_no ? data.sequence_no : "";
    newData.customer_name = data.Name;
    newData.customer_email = data.EmailID;
    newData.customer_mobile = data.Mobile;
    newData.checksumm = data.checkSum;
    newData.destination_dp = selectedNamelinnk;
    newData.ts = data.ts;
    newData.user_ip = await getClientIp();
    var postobjt = newData;

    console.log(postobjt);
    await contextapi
      .postApiAuthCalling(url, postobjt, true)
      .then((res) => {
        console.log(res);
      })
      .catch((error) => {
        console.log(error);
        // setNotifi({ val: true, msg: "Somthing went wrong" });
      });
  };
  const renderPophere = () => {
    if (showmodal) {
      return (
        <>
          <UserProfileModal
            openstatus={openstatus}
            closestatus={closestatus}
            confirmationName={confirmationName}
            TitleName=""
            dematLinksandName={selectedNamelinnk}
          />
        </>
      );
    } else {
      return <></>;
    }
  };

  useEffect(() => {
    if (referal === undefined || referal?.broker_name !== "") {
      switch (referal?.broker_name) {
        case "Bajaj Finserv":
          hidecomponent();
          openRedirectionLink(
            "https://ekyc2.bajajfinservsecurities.in/ekyc/?utm_source=Partner&utm_medium=''&utm_campaign=P4305",
            "Bajaj Finserv"
          );
          break;
        case "IIFL":
          hidecomponent();
          openRedirectionLink(
            "https://www.indiainfoline.com/open-demat-account?utm_source=alliance&utm_campaign=kfintech",
            "IIFL"
          );
          break;
        case "Religare":
          hidecomponent();
          openRedirectionLink(
            "https://www.religareonline.com/campaigns/licipo/?LeadDesc=EDAAO&utm_source=KFINTECH&utm_campaign=IPO&utm_keyword=LICIPO",
            "Religare"
          );
          break;
        case "Zerodha":
          hidecomponent();
          openRedirectionLink(
            "https://zerodha.com/open-account?c=ZOPHZA",
            "Zerodha"
          );
          break;
        case "Ventura Securities":
          hidecomponent();
          openRedirectionLink(
            "https://webkyc.ventura1.com/mobile.aspx?ref=dNpJnWeAR4W25zTdpER%2bTw%3d%3d&utm_source=lic-ipo-kfintech&utm_medium=banner&utm_campaign=lic-ipo-kfintech",
            "Ventura Securities"
          );
          break;
        case "KOTAK Securities":
          hidecomponent();
          openRedirectionLink(
            " https://www.kotaksecurities.com/landing-page/open-demat-account-with-kotak-securities-kfin/index.html",
            "KOTAK Securities"
          );
          break;
        case "ICICI Securities":
          hidecomponent();
          openRedirectionLink(
            "https://secure.icicidirect.com/accountopening?rmcode=KFINT471",
            "ICICI Securities"
          );
          break;
        case "Axis Securities":
          hidecomponent();
          openRedirectionLink(
            "https://digitalaccount.axisdirect.in/register?Segment=1&LGCode=BTKFIN&PromoCode=BTKFIN&PlanId=89&utm_source=KFINTECH&utm_campaign=Open_an_Account",
            "Axis Securities"
          );
          break;
        case "HDFC Securities":
          hidecomponent();
          openRedirectionLink(
            "https://allinone.hdfcsec.com/lp/open-trading-account16?lg-code=CPINF00001&lc-code=CPINF00001&source-code=9999&utm_Source=Alliance&utm_Content=homepage&utm_Campaign=Influencer",
            "HDFC Securities"
          );
          break;
        // case "Marwadi":
        //   hidecomponent();
        //   openRedirectionLink(
        //     "https://webkyc.marwadionline.com/#/referel?code=kfintech&type=web_open_account",
        //     "Marwadi"
        //   );
          // break;

        default:
          break;
      }
    }
  }, [referal]);

  return (
    <>
      <div className="row paddingzero">

      {(utmSource.toUpperCase() === 'NSDL' || utmSource === '') &&
          (referal === undefined ||
            referal?.broker_name === '' ||
            referal?.broker_name === 'IIFL') && (
            <div className=' col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12'>
              <div
                className='card'
                onClick={() =>
                  openRedirectionLink(
                    ' https://www.indiainfoline.com/open-demat-account?utm_source=alliance&utm_campaign=kfintech',
                    'IIFL'
                  )
                }
              >
                <div className='icons'>
                  <img src={iifl1} className='img' />
                </div>
                <div className='bluebg'>
                  <p>Click Here</p>
                </div>
              </div>
            </div>
              )} 
     
     

{/* {(utmSource.toUpperCase() === "NSDL" ||
          utmSource === "" ||
          utmSource.toUpperCase() === "CDSL") &&
          (referal === undefined ||
            referal?.broker_name === "" ||
            referal?.broker_name === "Marwadi") && (
            <div className=" col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <div
                className="card"
                onClick={() =>
                  openRedirectionLink(
                    "https://webkyc.marwadionline.com/#/referel?code=kfintech&type=web_open_account",
                    "Marwadi"
                  )
                }
              >
                <div className="icons">
                  <img src={Marwadi} className="img" />
                </div>
                <div className="bluebg">
                  <p>Click Here</p>
                </div>
              </div>
            </div>
          )} */}


        {(utmSource.toUpperCase() === "CDSL" ||
          utmSource === "" ||
          utmSource.toUpperCase() === "NSDL") &&
          (referal === undefined ||
            referal?.broker_name === "" ||
            referal?.broker_name === "Religare") && (
            <div className=" col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <div
                className="card"
                onClick={() =>
                  openRedirectionLink(
                    "https://www.religareonline.com/campaigns/licipo/?LeadDesc=EDAAO&utm_source=KFINTECH&utm_campaign=IPO&utm_keyword=LICIPO",
                    "Religare"
                  )
                }
              >
                <div className="icons">
                  <img src={religare} className="img" />
                </div>
                <div className="bluebg">
                  <p>Click Here</p>
                </div>
              </div>
            </div>
          )}


           {(utmSource.toUpperCase() === "NSDL" ||
          utmSource.toUpperCase() === "CDSL" ||
          utmSource === "") &&
          (referal === undefined ||
            referal?.broker_name === "" ||
            referal?.broker_name === "Bajaj Finserv") && (
            <div className=" col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <div
                className="card"
                onClick={() =>
                  openRedirectionLink(
                    "https://ekyc2.bajajfinservsecurities.in/ekyc/?utm_source=Partner&utm_medium=''&utm_campaign=P4305",
                    "Bajaj Finserv"
                  )
                }
              >
                <div className="icons">
                  <img src={Bajaj} className="img" />
                </div>
                <div className="bluebg">
                  <p>Click Here</p>
                </div>
              </div>
            </div>
          )}

        {(utmSource.toUpperCase() === "CDSL" ||
          utmSource === "" ||
          utmSource.toUpperCase() === "NSDL") &&
          (referal === undefined ||
            referal?.broker_name === "" ||
            referal?.broker_name === "HDFC Securities") && (
            <div className=" col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <div
                className="card"
                onClick={() =>
                  openRedirectionLink(
                    "https://allinone.hdfcsec.com/lp/open-trading-account16?lg-code=CPINF00001&lc-code=CPINF00001&source-code=9999&utm_Source=Alliance&utm_Content=homepage&utm_Campaign=Influencer",
                    "HDFC Securities"
                  )
                }
              >
                <div className="icons">
                  <img src={HDFC} className="img" />
                </div>
                <div className="bluebg">
                  <p>Click Here</p>
                </div>
              </div>
            </div>
          )}

        {(utmSource.toUpperCase() === "NSDL" ||
          utmSource === "" ||
          utmSource.toUpperCase() === "CDSL") &&
          (referal === undefined ||
            referal?.broker_name === "" ||
            referal?.broker_name === "KOTAK Securities") && (
            <div className=" col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <div
                className="card"
                onClick={() =>
                  openRedirectionLink(
                    " https://www.kotaksecurities.com/landing-page/open-demat-account-with-kotak-securities-kfin/index.html",
                    "KOTAK Securities"
                  )
                }
              >
                <div className="icons">
                  <img src={Kotak} className="img" />
                </div>
                <div className="bluebg">
                  <p>Click Here</p>
                </div>
              </div>
            </div>
          )}

{(utmSource.toUpperCase() === 'NSDL' ||
          utmSource.toUpperCase() === 'CDSL' ||
          utmSource === '') &&
          (referal === undefined ||
            referal?.broker_name === '' ||
            referal?.broker_name === 'ICICI Securities') && (
            <div className=' col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12'>
              <div
                className='card'
                onClick={() =>
                  openRedirectionLink(
                    'https://secure.icicidirect.com/accountopening?rmcode=KFINT471',
                    'ICICI Securities'
                  )
                }
              >
                <div className='icons'>
                  <img src={icici1} className='img' />
                </div>
                <div className='bluebg'>
                  <p>Click Here</p>
                </div>
              </div>
            </div>
          )} 

          
        {(utmSource.toUpperCase() === "NSDL" ||
          utmSource === "" ||
          utmSource.toUpperCase() === "CDSL") &&
          (referal === undefined ||
            referal?.broker_name === "" ||
            referal?.broker_name === "Zerodha") && (
            <div className=" col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <div
                className="card"
                onClick={() =>
                  openRedirectionLink(
                    "https://zerodha.com/open-account?c=ZOPHZA",
                    "Zerodha"
                  )
                }
              >
                <div className="icons">
                  <img src={zerodha} className="img" />
                </div>
                <div className="bluebg">
                  {/* <p>Account Opening Fee  - {toIndianCurrency(0)}</p> */}
                  {/* <p>Account Opening Fee  - 0</p> */}
                  <p>Click Here</p>
                </div>
              </div>
            </div>
          )}

{(utmSource.toUpperCase() === "NSDL" || utmSource === "") &&
          (referal === undefined ||
            referal?.broker_name === "" ||
            referal?.broker_name === "Axis Securities") && (
            <div className=" col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <div
                className="card"
                onClick={() =>
                  openRedirectionLink(
                    "https://digitalaccount.axisdirect.in/register?DP=No&IsCMLCopy=0&IsImage=No&lgcode=BTKFIN&lccode=BTKFIN&planId=112",
                    "Axis Securities"
                  )
                }
              >
                <div className="icons">
                  <img src={Axis} className="img" />
                </div>
                <div className="bluebg">
                  <p>Click Here</p>
                </div>
              </div>
            </div>
          )}


{/* {(utmSource.toUpperCase() === "NSDL" || utmSource === "") &&
          (referal === undefined ||
            referal?.broker_name === "" ||
            referal?.broker_name === "Ventura Securities") && (
            <div className=" col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
              <div
                className="card"
                onClick={() =>
                  openRedirectionLink(
                    "https://webkyc.ventura1.com/mobile.aspx?ref=dNpJnWeAR4W25zTdpER%2bTw%3d%3d&utm_source=lic-ipo-kfintech&utm_medium=banner&utm_campaign=lic-ipo-kfintech",
                    "Ventura Securities"
                  )
                }
              >
                <div className="icons">
                  <img src={ventura} className="img" />
                </div>
                <div className="bluebg">
                  <p>Click Here</p>
                </div>
              </div>
            </div>
          )} */}

        {/* <div className=" col-xl-3 col-lg-3 col-md-6 col-sm-6 col-12">
                    <div className="card" onClick={() => openRedirectionLink('https://ekyc.centrumbroking.com/#/registerfirst?utmCode=KFINTECH','Centrum')}>
                        <div className="icons">
                            <img src={Centrum} className="img" />
                        </div>
                        <div className="bluebg">
                        <p>Click Here</p>
                        </div>
                    </div>
                </div> */}

        {/* <div className="col-md-3">
                    <div className="card">
                        <div className="icons">
                            <img src={Kotak1} className="img" />
                        </div>
                        <div className="bluebg">
                            <p>Account Opening Fee  - ₹ 0</p>
                        </div>
                    </div>
                </div> */}
        {/* <div className="col-md-3">
                    <div className="card">
                        <div className="icons">
                            <img src={axis1} className="img" />
                        </div>
                        <div className="bluebg">
                            <p>Account Opening Fee  - ₹ 0</p>
                        </div>
                    </div>
                </div> */}
        {/* <div className="col-md-3">
                    <div className="card">
                        <div className="icons">
                            <img src={angel1} className="img" />
                        </div>
                        <div className="bluebg">
                            <p>Account Opening Fee  - ₹ 0</p>
                        </div>
                    </div>
                </div> */}
        {/* <div className="col-md-3">
                    <div className="card">
                        <div className="icons">
                            <img src={edelweiss1} className="img" />
                        </div>
                        <div className="bluebg">
                            <p>Account Opening Fee  - ₹ 0</p>
                        </div>
                    </div>
                </div> */}

        {/* <div className="col-md-3">
                    <div className="card">
                        <div className="icons">
                            <img src={hdfc1} className="img" />
                        </div>

                        <div className="bluebg">
                            <p>Account Opening Fee  - ₹ 0</p>
                        </div>
                    </div>
                </div> */}
      </div>

      {
        !isReferral && 
        <div className="col-md-12 textc">
          <button
            type="button"
            name="button"
            // className="btn btn-default mb-3"
            className="makewhitcolor btnInuse btn-default makewhitcolor mb-3"
            onClick={() => showAll()}
          >
            {" "}
            Show All
          </button>
        </div>
      }

      {renderPophere()}
    </>
  );
};

export default DematDashboard;
